/**
 * UD Event Design Tool Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AttributeTemplate} from '../models/AttributeTemplate';
import type {DecorationType} from '../models/DecorationType';
import type {Error} from '../models/Error';
import type {UserEventSource} from '../models/UserEventSource';

export interface GetDecorationTemplates$Request {
    source: UserEventSource;
    decorationType: DecorationType;
}

export interface GetDecorationTemplates$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDecorationTemplatesRequest = createAction<PayloadData<void, GetDecorationTemplates$Request>>('ATTRIBUTE_TEMPLATE_CONTROLLER__GET_DECORATION_TEMPLATES__REQUEST');
export const getDecorationTemplatesSuccess = createAction<PayloadData<Array<AttributeTemplate>, GetDecorationTemplates$Request>>('ATTRIBUTE_TEMPLATE_CONTROLLER__GET_DECORATION_TEMPLATES__SUCCESS');
export const getDecorationTemplatesFailure = createAction<PayloadData<Error, GetDecorationTemplates$Request, true>>('ATTRIBUTE_TEMPLATE_CONTROLLER__GET_DECORATION_TEMPLATES__FAILURE');

export const getDecorationTemplatesActions = [
    getDecorationTemplatesRequest,
    getDecorationTemplatesSuccess,
    getDecorationTemplatesFailure
] as const;

/**
 * @param {UserEventSource} meta.source Event source
 * @param {DecorationType} meta.decorationType Decoration type
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDecorationTemplates = (meta: GetDecorationTemplates$Request, config?: GetDecorationTemplates$Config) => {
    return {
        CALL_API: {
            types: getDecorationTemplatesActions,
            method: ApiMethods.GET,
            endpoint: `/attributes/decoration-template/${meta.source}/${meta.decorationType}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

